import BetModel from "../../core/src/model/BetModel";
import SpinModel from "../../core/src/model/SpinModel";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import App from "../../core/src/App";
import ErrorModel from "../../core/src/model/ErrorModel";
import PromotionalFreeGamesModel from "../model/PromotionalFreeGamesModel";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import { State } from "../../core/src/states/State";
import DebugModel from "../../core/src/model/DebugModel";
import { Tween } from "../../core/src/Tween";
import ScatterModel from "../../../game/src/models/ScatterModel";

export default class VendorSpinGetResultState extends State {

    protected _canExit: boolean;

    enter(){
        this._canExit = false;
        super.enter();
        this.sendRequest();
    }

    sendRequest() {
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins() && !SpinModel.leftoverCascades) {
            SpinModel.spinFinished = false;
            CommManager.send(
                RequestRegister.get("getResult"),
                this.onResponse,
                this
            )
        } else {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            );
            App.timeline.call(
                this.onResponse,
                [],
                this,
                App.timeline.time + 0.5
            );
        }
    }

    protected onResponse(data?: any) {
        this._canExit = true;
        let exitDelayInSeconds = 0;
        // In case the fake response cheat is used,
        // we need to change the server data with the fake one.
        // We also need to delay the current state exit
        // in order to give a chance the next state to be able
        // to get the fake data instead of the server's one.
        if (data && DebugModel.fakeResponse) {
            if (data.request == DebugModel.fakeResponse.request) {
                // Modifying the data directly.
                // This way the inherited classes will get the fake one,
                // in case they first call super.onResponse(data);
                Object.assign(data, DebugModel.fakeResponse);
                exitDelayInSeconds = 0.050;
            }
        }

        // Make sure we will substitute the response only once.
        DebugModel.fakeResponse = null;

        SpinModel.update(data);
        PromotionalFreeGamesModel.update(data);
        ErrorModel.update(data);
        BetModel.update(data);
        // VendorModel.update(data);
        if (SpinModel.isInFreespins()) {
            // this.anounce(); // TODO
        }

        Tween.delayedCall(exitDelayInSeconds, () => { this.exit() }, [], this);
    }
}
